import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { L10N_LOCALE, L10nTranslatePipe } from 'angular-l10n';
import { map } from 'rxjs';
import { AuthService } from 'src/app/shared/authentication/auth.service';
import {
  DASHBOARD_LAYOUT_VERSION,
  DashboardGridComponent,
  DashboardLayout,
  provideDashboard,
} from 'src/app/shared/dashboard-grid';
import { DASHBOARD_WIDGETS } from './dashboard-widgets';

export const DASHBOARD_ID = 'dashboard';

const DEFAULT_LAYOUT: DashboardLayout = { version: DASHBOARD_LAYOUT_VERSION, widgets: [] };

/** HomeComponent shows this instead of the legacy admin home for users with `hickory.enterprise-dashboard`. */
@Component({
  selector: 'app-dashboard',
  template: `
    <app-dashboard-grid>
      <h1 dashboardTitle class="dashboard__title">{{ 'Dashboard.Title' | translate: locale.language }}</h1>
      @if (tenantName()) {
        <span dashboardSubtitle>{{ tenantName() }}</span>
      }
    </app-dashboard-grid>
  `,
  styles: `
    :host {
      display: block;
      padding: 24px;
    }

    .dashboard__title {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
  `,
  imports: [DashboardGridComponent, L10nTranslatePipe],
  providers: [provideDashboard({ id: DASHBOARD_ID, defaultLayout: DEFAULT_LAYOUT, widgets: DASHBOARD_WIDGETS })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  protected readonly locale = inject(L10N_LOCALE);
  private readonly auth = inject(AuthService);
  protected readonly tenantName = toSignal(this.auth.user.data.pipe(map((user) => user?.agency)));
}
